<template>
  <!-- блокировка заказа (Эмити): замок + посекундный обратный отсчёт до авторазблокировки (48 ч) -->
  <v-tooltip bottom max-width="480">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-icon color="error" small>mdi-lock</v-icon>
        <code class="caption font-weight-bold">{{ label }}</code>
      </span>
    </template>
    <span>
      <b>{{ stringValues.orderBlockedByDistributor[currentLanguage.language] }}.</b>
      {{ stringValues.blockedOrderTimerHint[currentLanguage.language] }}
    </span>
  </v-tooltip>
</template>

<script>
// Отдельный компонент, чтобы каждую секунду перерисовывался только счётчик, а не весь список заказов.
// Отсчёт идёт локально от secondsLeft, который пришёл со списком блокировок при входе в потребность.
// Ноль на фронте — не повод снимать блокировку, а повод спросить бэк: перечитываем список;
// если бэк вернул заказ снова (часы клиента ушли, повторная блокировка) — стор получает свежий secondsLeft,
// отсчёт продолжается, кнопки остаются неактивными; если не вернул — родитель убирает компонент по v-if.
// При ошибке сети прежняя блокировка сохраняется, проверка повторяется через VERIFY_RETRY_MS.
const VERIFY_RETRY_MS = 5000;

export default {
  name: "BlockedOrderTimer",
  props: {
    orderId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    now: Date.now(),
    timer: null,
    verifying: false,
    lastVerifiedAt: 0,
  }),
  computed: {
    stringValues() {
      return this.$store.getters.STRING_VALUES;
    },
    currentLanguage() {
      return this.$store.getters.CURRENT_LANG;
    },
    secondsLeft() {
      return this.$store.getters["blockedOrder/secondsUntilUnblock"](this.orderId, this.now);
    },
    label() {
      const t = this.stringValues;
      const lang = this.currentLanguage.language;

      if (this.secondsLeft <= 0) {
        return t.blockCheck[lang];
      }

      const hours = Math.floor(this.secondsLeft / 3600);
      const minutes = Math.floor((this.secondsLeft % 3600) / 60);
      const seconds = this.secondsLeft % 60;
      return `${t.unblockIn[lang]} ${hours} ${t.hoursShort[lang]} ${this.pad(minutes)} ${t.minutesShort[lang]} ${this.pad(seconds)} ${t.secondsShort[lang]}`;
    },
  },
  methods: {
    pad(value) {
      return String(value).padStart(2, "0");
    },
    tick() {
      this.now = Date.now();

      if (this.secondsLeft > 0 || this.verifying) return;
      if (this.now - this.lastVerifiedAt < VERIFY_RETRY_MS) return;

      this.verify();
    },
    async verify() {
      this.verifying = true;
      try {
        await this.$store.dispatch("blockedOrder/fetchMyBlockedOrders");
      } finally {
        this.lastVerifiedAt = Date.now();
        this.now = this.lastVerifiedAt;
        this.verifying = false;
      }
    },
  },
  mounted() {
    this.timer = setInterval(this.tick, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
